import { render, staticRenderFns } from "./BaseInputCurrency.vue?vue&type=template&id=4e79fffc&scoped=true&"
import script from "./BaseInputCurrency.vue?vue&type=script&lang=ts&"
export * from "./BaseInputCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputCurrency.vue?vue&type=style&index=0&id=4e79fffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e79fffc",
  null
  
)

export default component.exports